module.exports = "/static/images/model_number.svg";